export const env: { [s: string]: (string | null); } = {
  'npm_package_version': '4.12.8',
  'APP_INSIGHTS_CONNECTION_STRING': 'InstrumentationKey=d9de85d8-e9ca-4ace-a801-584992a801c3;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/;ApplicationId=781ef1df-f9a9-448a-82d3-3a3910b29fb1',
  'APPLICATIONINSIGHTS_CONNECTION_STRING': 'InstrumentationKey=d9de85d8-e9ca-4ace-a801-584992a801c3;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/;ApplicationId=781ef1df-f9a9-448a-82d3-3a3910b29fb1',
  'FOLLOWUP_API_KEY_AUTH': '',
  'API_KEY_AUTH': ''
};
